// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Qx1u+","content":"styles_content__JUK5l"};